import msalInstance from '../../../../auth/config';
import { scopes } from '../../../../constants/auth';

function getRuntimeConfigValue(key: string): string | undefined {
  const cfg = (globalThis as any).__APP_CONFIG__;
  const value = cfg?.[key];
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

function getApiBaseUrl(): string {
  const value =
    process.env.REACT_APP_SM_POSTGRES_API_URL ||
    getRuntimeConfigValue('REACT_APP_SM_POSTGRES_API_URL');

  if (!value) {
    throw new Error('Falta REACT_APP_SM_POSTGRES_API_URL para Gestión de Servicios.');
  }

  return value.replace(/\/$/, '');
}

async function getAccessToken(): Promise<string> {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (!account) throw new Error('No hay una sesión activa para acceder a Gestión de Servicios.');

  const result = await msalInstance.acquireTokenSilent({ account, scopes });
  return result.accessToken;
}

export async function serviceManagementRequest<T>(
  path: string,
  init: RequestInit = {}
): Promise<T> {
  const accessToken = await getAccessToken();
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${accessToken}`);
  headers.set('Accept', 'application/json');
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(`${getApiBaseUrl()}${path}`, { ...init, headers });
  if (!response.ok) {
    const text = await response.text();
    let message = text || `Error HTTP ${response.status}`;
    try {
      const parsed = JSON.parse(text);
      message = parsed?.error || message;
    } catch {
      // Keep the plain response body.
    }
    throw new Error(message);
  }

  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
